/** Stable ULID from beatq-eats-nodejs/prisma/seeds/reference-data.ts DEV_SCOPE — fixtures/tests only. */
export const DEV_BUSINESS_ACCOUNT_ID = '01JDEVBACCOUNT00000000001';

const STORAGE_KEY = 'beatq.business.activeBusinessAccountId';

export function getStoredBusinessAccountId(): string | null {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function setStoredBusinessAccountId(id: string | null): void {
  try {
    if (id) localStorage.setItem(STORAGE_KEY, id);
    else localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** Claims `bac`, then storage. Never the seed ULID. */
export function resolveBusinessAccountId(claimsBac?: string | null): string | null {
  return claimsBac || getStoredBusinessAccountId() || null;
}
